import React, { ReactPropTypes } from 'react'
import resolveProps from '../../utils/resolveProps'
import { ColProps, Size, FakeProps } from './types'

export default function Col(props: ColProps) {
  const { children, fluid, xs, sm, md, lg, xl, ...rest } = props
  const fakeProps: FakeProps = {}
  const regex = /Col--offset/g;

  const filteredProps = Object.entries(props)
    .filter((item) => ['xs', 'sm', 'md', 'xl', 'lg'].indexOf(item[0]) > -1)
    .reduce((obj, [key, value]) => ({ ...obj, [key]: value}), {})

    Object.entries(filteredProps).map(([key, value]: [string, Size]) => {


    if (typeof value === 'number') {
      fakeProps[`${key}-${value}`] = true
    } else { // multiple parameters
      typeof value.span === 'number' && (fakeProps[`${key}-${value.span}`] = true)
      typeof value.offset === 'number' && (fakeProps[`offset-${key}-${value.offset}`] = true)
    }
  })


  const mdnClassName = resolveProps({ ...fakeProps, ...rest }, config, 'Col', '-').replace(regex, 'Offset').trim()

  return (
    <div {...rest} className={mdnClassName}>
      {children}
    </div>
  )
}

const config = {
  types: [
    'xs-1',
    'xs-2',
    'xs-3',
    'xs-4',
    'xs-5',
    'xs-6',
    'xs-7',
    'xs-8',
    'xs-9',
    'xs-10',
    'xs-11',
    'xs-12',
    'sm-1',
    'sm-2',
    'sm-3',
    'sm-4',
    'sm-5',
    'sm-6',
    'sm-7',
    'sm-8',
    'sm-9',
    'sm-10',
    'sm-11',
    'sm-12',
    'md-1',
    'md-2',
    'md-3',
    'md-4',
    'md-5',
    'md-6',
    'md-7',
    'md-8',
    'md-9',
    'md-10',
    'md-11',
    'md-12',
    'lg-1',
    'lg-2',
    'lg-3',
    'lg-4',
    'lg-5',
    'lg-6',
    'lg-7',
    'lg-8',
    'lg-9',
    'lg-10',
    'lg-11',
    'lg-12',
    'xl-1',
    'xl-2',
    'xl-3',
    'xl-4',
    'xl-5',
    'xl-6',
    'xl-7',
    'xl-8',
    'xl-9',
    'xl-10',
    'xl-11',
    'xl-12',
    'offset-xs-1',
    'offset-xs-2',
    'offset-xs-3',
    'offset-xs-4',
    'offset-xs-5',
    'offset-xs-6',
    'offset-xs-7',
    'offset-xs-8',
    'offset-xs-9',
    'offset-xs-10',
    'offset-xs-11',
    'offset-xs-12',
    'offset-sm-1',
    'offset-sm-2',
    'offset-sm-3',
    'offset-sm-4',
    'offset-sm-5',
    'offset-sm-6',
    'offset-sm-7',
    'offset-sm-8',
    'offset-sm-9',
    'offset-sm-10',
    'offset-sm-11',
    'offset-sm-12',
    'offset-md-1',
    'offset-md-2',
    'offset-md-3',
    'offset-md-4',
    'offset-md-5',
    'offset-md-6',
    'offset-md-7',
    'offset-md-8',
    'offset-md-9',
    'offset-md-10',
    'offset-md-11',
    'offset-md-12',
    'offset-lg-1',
    'offset-lg-2',
    'offset-lg-3',
    'offset-lg-4',
    'offset-lg-5',
    'offset-lg-6',
    'offset-lg-7',
    'offset-lg-8',
    'offset-lg-9',
    'offset-lg-10',
    'offset-lg-11',
    'offset-lg-12',
    'offset-xl-1',
    'offset-xl-2',
    'offset-xl-3',
    'offset-xl-4',
    'offset-xl-5',
    'offset-xl-6',
    'offset-xl-7',
    'offset-xl-8',
    'offset-xl-9',
    'offset-xl-10',
    'offset-xl-11',
    'offset-xl-12'
  ],
  modifiers: [],
  states: []
}
